<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/miir/products/*', { eager: true });

useHead({});

const products = [
	{
		title: 'Bahia 40L XL Tote',
		src: imagesGlob['../../images/brands/miir/products/bahia-40l-xl-tote.jpg'].default
	},
	{
		title: '16 oz. Sipper Straw Bottle',
		src: imagesGlob['../../images/brands/miir/products/16-oz-sipper-straw-bottle.jpg'].default
	},
	{
		title: 'Olympus 2.0 2L Sling Bag',
		src: imagesGlob['../../images/brands/miir/products/olympus-20-2l-sling-bag.jpg'].default
	},
	{
		title: '16 oz. Vacuum Insulated Camp Cup',
		src: imagesGlob['../../images/brands/miir/products/16-oz-vacuum-insulated-camp-cup.jpg'].default
	},
	{
		title: '10 oz. Vacuum Insulated Wine Tumbler',
		src: imagesGlob['../../images/brands/miir/products/10-oz-vacuum-insulated-wine-tumbler.jpg'].default
	},
	{
		title: '16 0z. Vacuum Insulated Travel Tumbler',
		src: imagesGlob['../../images/brands/miir/products/16-0z-vacuum-insulated-travel-tumbler.jpg'].default
	},
	{
		title: '33 oz. Everywhere Bottle',
		src: imagesGlob['../../images/brands/miir/products/33-oz-everywhere-bottle.jpg'].default
	},
	{
		title: 'Olympus 2.0 25L Laptop Backpack',
		src: imagesGlob['../../images/brands/miir/products/olympus-20-25l-laptop-backpack.jpg'].default
	},
	{
		title: '32 oz. Vacuum Insulated Wide Mouth Bottle',
		src: imagesGlob['../../images/brands/miir/products/32-oz-vacuum-insulated-wide-mouth-bottle.jpg'].default
	},
]
</script>

<template lang="pug">
.page.page--brand.miir
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/miir/logo.png')
				h1 Custom Miir
			.image
				img(src='@static/images/brands/miir/hero.jpg' alt="Three MiiR tumblers on a wooden table outdoors, one with a tea bag inside, suggesting a camping setting.")
	section.section.section--subhero
		.section__content
			.copy
				h3 DESIGN FORWARD. GENEROSITY DRIVEN.
				p Say hello to gear that does more than just look good. Custom MiiR by Swagger is where premium design meets purpose-driven impact. Crafted to go everywhere, built to last, and made to give back. Every piece blends form and function in all the right ways: modern silhouettes, intentional details, and sustainability baked in from the start. Whether you’re hitting the trail, the office, or the road, this is gear that carries your brand values every step of the way.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Miir ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="miir")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/miir/banner.webp' alt="A woman washes materials by hand at an outdoor workstation, part of a Miir funded community project supporting clean water and sustainable livelihoods.")
			.section__content
				.copy
					h2 TRACE THE IMPACT
					p MiiR isn’t just along for the journey, they’re helping shape a better one. As a certified B Corp and Climate Neutral company, MiiR commits a portion of every sale to organizations focused on clean water, community, and environmental justice. And with every product tied to a unique Give Code™, you can actually trace the impact. It’s sustainable gifting that’s transparent, meaningful, and built to be used (and appreciated) every day.
		
		section.section.section--foot
			.bg
			.section__content
				.pack
					.item
						img(src='@static/images/brands/miir/pack-1.webp' alt="A hand holds a bright yellow MiiR tumbler lid while taking a photo of its unique Give Code™, which connects purchases to funded community projects.")
					.item
						img(src='@static/images/brands/miir/pack-2.png' alt="Text reading ‘Design forward. Generosity driven.’ explains how each MiiR product helps fund transparent giving projects, with a field to enter a Give Code™.")
					.item
						img(src='@static/images/brands/miir/pack-3.png' alt="A group of smiling community members celebrate together outdoors, representing a MiiR-funded project that supports local empowerment and sustainability.")
		
</template>

<style></style>